export const blockIconsHardwareKeyboardVoice = (
	<span className='material-symbols-outlined'>keyboard_voice</span>
);
